import React, { Component } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';

import { formatDate } from '../../utils/functions';
import { ElementLink } from '../../components';

import { formatMessageableType } from './Helpers';

export class MessageCellView extends Component {
  render() {
    const { message } = this.props;

    const messageToDisplay = message.messageDisplay || message;

    return (
      <ElementLink
        element="tr"
        to={`/messages/${message.id}/edit`}
        className="message-cell"
      >
        <td>{messageToDisplay.title}</td>
        <td>{messageToDisplay.body}</td>
        <td>{formatDate(messageToDisplay.endDate)}</td>
        <td>{formatMessageableType(message.messageableType)}</td>
      </ElementLink>
    );
  }
}

export default createFragmentContainer(MessageCellView, {
  message: graphql`
    fragment MessageCell_message on Message {
      id
      title
      body
      endDate
      messageableType
      messageDisplay {
        title
        body
        endDate
      }
    }
  `,
});
